export class Fee {
	private allow_sending: "internal" | "external" | "both" = "internal";
	private external_fee: string = "0";
	public fiat_fee: string;
	public fiat_fee_currency: string;

	public get fee(): number {
		return +this.external_fee;
	}

	public getAllowSending(): string {
		return this.allow_sending;
	}
}
